import React from 'react';
import { componentService } from 'js/services/component.service';

export const CookieSettings = React.lazy(() => import(/* webpackChunkName: "cookie-settings" */ './CookieSettings'));

componentService.registerWebContentComponents({ CookieSettings });
